import React, { useEffect } from 'react';
import { Button, InputText } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { useHistory } from 'react-router-dom';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { createStyles } from './styles';

/** This form will be changed after we have created a stable solution for npn/tin users. */
const AccountSettingsForm = observer((): JSX.Element => {
  const classes = createStyles();
  const history = useHistory();

  const {
    accountSettingsStore: { loading, accountSettingsForm, getUserInfo, updateUserInfo },
  } = useRootStore();

  useEffect(() => {
    void getUserInfo();
  }, []);

  const onFormSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    await updateUserInfo();
  };

  const goBack = (): void => {
    history.goBack();
  };

  return (
    <form id="account-settings-form" onSubmit={onFormSubmit} className={classes.form}>
      <div className={classes.formElements}>
        <InputText
          value={accountSettingsForm.fields.firstName.value}
          onChange={accountSettingsForm.onFieldChange}
          name="firstName"
          label="First Name"
          className={classes.input}
          validationMessage={accountSettingsForm.fields.firstName.unpassedValidationMsg || ''}
          validationPassed={!accountSettingsForm.fields.firstName.unpassedValidationMsg}
        />
        <InputText
          value={accountSettingsForm.fields.lastName.value}
          onChange={accountSettingsForm.onFieldChange}
          name="lastName"
          label="Last Name"
          className={classes.input}
          validationMessage={accountSettingsForm.fields.lastName.unpassedValidationMsg || ''}
          validationPassed={!accountSettingsForm.fields.lastName.unpassedValidationMsg}
        />
        <InputText
          value={accountSettingsForm.fields.telephone.value}
          onChange={accountSettingsForm.onFieldChange}
          name="telephone"
          label="Phone Number"
          className={classes.input}
          maxLength={10}
          validationMessage={accountSettingsForm.fields.telephone.unpassedValidationMsg || ''}
          validationPassed={!accountSettingsForm.fields.telephone.unpassedValidationMsg}
        />
        <InputText
          value={accountSettingsForm.fields.npn.value}
          onChange={accountSettingsForm.onFieldChange}
          name="npn"
          label="Npn"
          className={classes.input}
          maxLength={9}
          validationMessage={accountSettingsForm.fields.npn.unpassedValidationMsg || ''}
          validationPassed={!accountSettingsForm.fields.npn.unpassedValidationMsg}
        />
      </div>
      <div className={classes.buttonWrapper}>
        <Button type="outlined" size="large" width="20rem" onClick={goBack}>
          Cancel
        </Button>
        <Button
          htmlType="submit"
          color="primary"
          size="large"
          width="20rem"
          disabled={!accountSettingsForm.isFormValid() || loading}
        >
          Change Account
        </Button>
      </div>

      <FormsSpinner display={loading} />
    </form>
  );
});

export default AccountSettingsForm;
